import { createSelector } from 'reselect'
import { formValueSelector as getFormValueSelector } from 'redux-form'
//@ts-ignore
import { isFieldTouched } from 'shared/reduxForm'
import { getData, getFetchSucceeded, getPending } from 'loankeeper-common/helpers/SimpleFetchManager'
import { translate } from './helpers'
import { DefaultRootState } from 'react-redux'
import { GridOptions } from 'ag-grid'
import { ClientDataTypes } from './types'
import { getClientsFetchSucceeded, getClientsCount } from 'src/store/client'
export const formValueSelector = (state: DefaultRootState, { instanceName }: { instanceName: string }, field: string) =>
  getFormValueSelector(instanceName)(state, field)

export const isFormFieldTouched = (
  state: DefaultRootState,
  { instanceName }: { instanceName: string },
  field: string,
): boolean => isFieldTouched(instanceName)(state, field)

const defaultClients = []
export const getClients = (
  state: DefaultRootState,
  { instanceName }: { instanceName: string; gridConfig?: GridOptions },
): ClientDataTypes[] => getData(instanceName)(state) || defaultClients

// export const getClientsFetchSucceeded = (state: DefaultRootState, { instanceName }) => getFetchSucceeded(instanceName)(state) || false

// export const getClientsCount = createSelector(getClients, (clients) => clients.length)

export const getAppsFetching = (
  state: DefaultRootState,
  { instanceName }: { instanceName: string; gridConfig?: GridOptions },
): boolean => getPending(instanceName)(state) || false

// export const getTitle = createSelector(
//   getClientsFetchSucceeded,
//   getClientsCount,
//   (clientsFetchSucceeded, clientsCount) => {
//     if (clientsFetchSucceeded) {
//       return `${translate('lbl_clients_cap')} ${clientsCount} ${translate('lbl_clients_cap_rec')}`
//     }

//     return translate('frm_client_list')
//   },
// )

export const getTitle = createSelector(
  getClientsFetchSucceeded,
  getClientsCount,
  (clientsFetchSucceeded, clientsCount) => {
    if (clientsFetchSucceeded) {
      return `${translate('lbl_clients_cap')} ${clientsCount} ${translate('lbl_clients_cap_rec')}`
    }

    return translate('frm_client_list')
  },
)
